export const ASKUS_LIST_VAR = 'ASKUs_list';
export const VENDOR_BOOSTS_COMPOSABLE_ID = 'vendorBoosts';
export const VENDOR_BOOSTS_SBLOK_URL = 'content/search-io-boosted-brands';
